module.exports = __webpack_public_path__ + "static/media/time.ccc54281.jpg";